import { MaterialCommunityIcons } from '@expo/vector-icons';
import { Colors } from 'libs/shared-ui/src/themes';
import { useTranslation } from 'react-i18next';
import { Pressable, StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';

export const DuplicateQuestion = ({
  i18nPrefix,
  onPress,
}: {
  i18nPrefix: string;
  onPress: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <View style={styles.duplicateQuestion}>
      <Pressable onPress={onPress} style={styles.button}>
        <MaterialCommunityIcons name="plus" color={Colors.primary} size={24} />
        <Text style={{ color: Colors.primary }}>
          {t(`${i18nPrefix}.duplicateQuestion`)}
        </Text>
      </Pressable>
    </View>
  );
};

const styles = StyleSheet.create({
  duplicateQuestion: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  button: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
  },
});
